/* eslint-disable */
/*
Purpose: very basic login, no errors reported

Notes: needs to be more fully fleshed out
*/

import React, { Component } from "react"
import { StackNavigator } from 'react-navigation';
import {

  View,
 
  Keyboard
} from "react-native"
import { connect } from "react-redux"

import ProfilePhoto from "../Components/ProfilePhoto"
import ProfilePhotoCell from "../Components/ProfilePhotoCell"
import InputCell from "../Components/InputCell"
import FooterButton from "../Components/FooterButton"
import NavigationBar from "../Components/NavigationBar"
import { Images } from "../Themes"
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view'
import BadgeButton from '../Components/BadgeButton'
import { validateSignIn } from '../Components/ValidateComponent'
import AuthActions from '../Redux/AuthRedux'
import { Field, reduxForm, startSubmit } from 'redux-form';
import styles from "./Styles/LoginScreenStyle"
import BaseScreen from "./BaseScreen";
import I18n from "i18n-js"

class LoginScreen extends Component {
  constructor(props) {
    super(props)
    this.state = {
      username: "",
      password: ""
    }
  }

  static navigationOptions = {
    header: null
  }
  componentDidMount() {

    this.navigationBar.setLeftNavBarButtons([
      { onPress: this.onBackPress, type: 'back' },
    ])
  }
  onBackPress = () => {
    this.props.navigation.goBack()
  }
  isValid = () => {
    return this.state.username && this.state.password
  }

  login = (values) => {

    Keyboard.dismiss()
    this.props.navigation.dispatch(startSubmit('LoginForm'))
    return new Promise((resolve, reject) => {
      this.props.loginUser({ ...values, resolve, reject })
    });

  }
  keyboardAccessory = () => (
    <FooterButton
    disabled={!this.isValid() || this.props.submitting}
      onPress={this.props.handleSubmit(this.login)}
      style={styles.footerButton}
      title={I18n.t('login.title')}
    />
  )
  render() {
    const disabled = !this.isValid()
    const { photo } = this.state

    const { submitting, handleSubmit } = this.props

    return (
      <BaseScreen
        keyboardAccessory={this.keyboardAccessory()}
        showKeyboardAccessory={disabled}
        fullLoading={submitting}>
        <NavigationBar
          ref={(view) => {
            if (view) this.navigationBar = view
          }}

          title={I18n.t('login.title')}
        />
        <KeyboardAwareScrollView
        extraScrollHeight = {80}
         style={styles.container}>
          <ProfilePhotoCell >
            <ProfilePhoto path={photo && photo.path}>
            </ProfilePhoto>
          </ProfilePhotoCell>
          <Field name="username"
            separator
            autoCapitalize="none"
            autoCorrect={false}
            onChange={(text) => {
              this.setState({ username: text.replace(/\s/g, "_") })
            }}
            placeholder={`johnappleseed`}
            newValue = {this.state.username}
            title={I18n.t('login.username')}
            value={this.state.username}
            component={InputCell}
          />
          <Field name="password"
            separator
            autoCorrect={false}
            onChange={(text) => {
              this.setState({ password: text })
            }}
            placeholder={`********`}
            secure={true}

            title={I18n.t('login.password')}
            value={this.state.password}
            component={InputCell}
          />
        </KeyboardAwareScrollView>
        <View style={{ marginVertical: 0 }}>
          <FooterButton
            disabled={!this.isValid() || submitting}
            onPress={handleSubmit(this.login)}
            style={styles.footerButton}
            title={I18n.t('login.title')}
          />
        </View>
      </BaseScreen>
    )
  }

}

const mapStateToProps = state => ({ auth: state.auth })

// wraps dispatch to create nicer functions to call within our component
const mapDispatchToProps = dispatch => ({
  loginUser: (values) => dispatch(AuthActions.authRequest(values)),
  startSubmit: (LoginForm) => dispatch(startSubmit(LoginForm))
})
const LoginForm = reduxForm({
  form: 'LoginForm',
  validate: validateSignIn
})(LoginScreen)
export default connect(mapStateToProps, mapDispatchToProps)(LoginForm)
